import { Component, OnInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { LayoutService } from '../../../services/layout.service';
export class ProfileButtonComponent implements OnInit {
/**
 * @param {?} render
 * @param {?} el
 * @param {?} ls
 */
constructor(
private render: Renderer2,
private el: ElementRef,
private ls: LayoutService
  ) { }
/**
 * @return {?}
 */
ngOnInit() {
        if (this.el.nativeElement.querySelector('.close-on-click')) {
            this.render.listen(this.el.nativeElement.querySelector('.close-on-click'), 'click', () => {
                this.ls.closeOverlay.next(true);
            });
        }
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[hd-profile-button]',
  template: `
    <ng-content></ng-content>
  `,
  styles: [`
    :host{
        display: block;
        padding: 20px 20px;
        padding-top:0;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
{type: LayoutService, },
];
}

function ProfileButtonComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProfileButtonComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProfileButtonComponent.ctorParameters;
/** @type {?} */
ProfileButtonComponent.prototype.render;
/** @type {?} */
ProfileButtonComponent.prototype.el;
/** @type {?} */
ProfileButtonComponent.prototype.ls;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
